export default __webpack_public_path__ + "static/media/video_effects_right_frame.30c72800.png";